import { Flex } from "@chakra-ui/react";
import { FC, ReactNode, useCallback, useState } from "react";

import { GhostButton, SolidButton } from "~/src/components/common/Button";
import { ConfirmDialog } from "~/src/components/features/global/ConfirmDialog";

export type Props = {
  onConfirm: () => void;
  onCancelClick: () => void;
  message: ReactNode;
  disabled: boolean;
  loading: boolean;
  cancelDisabled?: boolean;
};

export const ConfirmationButtons: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({
  onConfirm,
  onCancelClick,
  message,
  disabled,
  loading,
  cancelDisabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConfirm = useCallback(() => {
    setIsOpen(false);
    onConfirm();
  }, [onConfirm]);

  const handleClick = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <Flex mt="40px" justifyContent="flex-end">
        <GhostButton
          mr="8px"
          onClick={onCancelClick}
          isDisabled={cancelDisabled}
        >
          戻る
        </GhostButton>
        <SolidButton
          type="button"
          onClick={handleClick}
          isDisabled={disabled}
          isLoading={loading}
        >
          保存
        </SolidButton>
      </Flex>
      <ConfirmDialog
        isOpen={isOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        title={"確認"}
        message={message}
      />
    </>
  );
};
